import { create } from "zustand"

const useFetchUpcomingDesignerOrders = create((set) => ({
  designerOrders: [],
  designerOrdersCount: 0, // State variable to hold the count of objects in the array
  loading: true,
  setDesignerOrders: (orders) =>
    set({ designerOrders: orders, designerOrdersCount: orders.length, loading: false }),
  setDesignerOrdersLoading: (loadingState) => set({ loading: loadingState }),
}))

export default useFetchUpcomingDesignerOrders
